export enum TipoCarroceria {
  ABERTO = 'ABERTO',
  BAU = 'BAÚ',
  FRIGORIFICO = 'FRIGORÍFICO',
  REFRIGERADO = 'REFRIGERADO',
  SIDER = 'SIDER',
  OUTROS = 'OUTROS',
  NAOSEAPLICA = 'NÃO SE APLICA',
}
